import { SocialLinks as SocialLinksType } from "../../../sanity/lib/queries/getNavigationData";

export const SocialLinks = ({ socialLinks }: { socialLinks: SocialLinksType[] }) => {
    return (
        <div className="flex-col hidden gap-4 social-links lg:flex">
            {socialLinks.map((element) => (
                <div key={element._key}>
                    <a href={element.external} className="hover:no-underline m-link-l xl:d-link-l">
                        {element.label}
                    </a>
                </div>
            ))}
        </div>
    );
};
